import { ExperienceResponse, ExperiencesResponse } from './models';

import { createQuery } from '../../libs';
import { long_term_cashing } from '@/constants/cashing';

const url = 'experiences';

export const useGetExperiences = createQuery<ExperiencesResponse, unknown>(
  {
    method: 'get',
    url: `${url}`,
  },
  {
    staleTime: long_term_cashing,
  }
);

export const useGetExperience = createQuery<
  ExperienceResponse,
  unknown,
  string,
  {
    cityId: number;
  }
>({
  url: `${url}/unique-name/:slug`,
  method: 'get',
});
